import React from "react";

import styled from "styled-components/macro";

import { colors } from "constants/theme";

import LogoIcon from "img/AgriNous-icon";

interface IconWrapperProps {
  backgroundColor: keyof typeof colors;
  size: number;
}

const IconWrapper = styled.div<IconWrapperProps>`
  ${({ theme, backgroundColor, size }) => `
  width: ${size}px;
  height: ${size}px;
  border-radius: ${size / 2}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors[backgroundColor]};
  margin: auto ${theme.space[1]}px;
`}
`;

interface AgriNousLogoProps {
  backgroundColor: keyof typeof colors;
  color: keyof typeof colors;
  envColor?: keyof typeof colors;
  scale?: number;
  size?: number;
}

export const AgriNousLogo = ({
  backgroundColor,
  color,
  envColor = undefined,
  scale = 0.7,
  size = 36,
}: AgriNousLogoProps): React.JSX.Element => {
  return (
    <IconWrapper backgroundColor={backgroundColor} size={size}>
      <LogoIcon color={color} envColor={color || envColor} scale={scale} />
    </IconWrapper>
  );
};

interface AgriNousActiveLogoProps {
  isActive?: boolean;
  scale?: number;
  size?: number;
}

const AgriNousActiveLogoComponent = ({
  isActive,
  scale = 0.7,
  size = 36,
}: AgriNousActiveLogoProps): React.JSX.Element => {
  // Simple wrapper around the AgriNousLogo that takes a boolean instead of a color.
  const backgroundColor = isActive ? "successGreen" : "grayDisabled";
  const color = isActive ? "white" : "gray9C";
  return (
    <AgriNousLogo
      color={color}
      backgroundColor={backgroundColor}
      scale={scale}
      size={size}
    />
  );
};

const AgriNousActiveLogo = React.memo(AgriNousActiveLogoComponent);

export default AgriNousActiveLogo;
